module.exports = __webpack_public_path__ + "static/vector-shape4-3f535f93904f867f76fb0586dfc899f3.png";